import { createUseStyles } from 'react-jss';

export const useStylesAccordion = createUseStyles({
  root: {
    borderRadius: "8px",
    overflow: "hidden",
    color: "#fff",
    "& .MuiAccordionSummary-content": {
      margin: "0 !important",
      display: "flex",
      alignItems:"center",
    },
    "& .MuiPaper-root.MuiPaper-elevation": {
      boxShadow: "none",
    },
    "& .MuiAccordionSummary-root": {
      background: "#0f314d",
      color: "#ffffff",
      fontWeight: "300",
      fontSize: "18px",
      height: "59px",
      padding: "0 32px",
    },
    "& .MuiAccordionDetails-root": {
      padding: 0,
    },
  },
});

export const useStylesAccordionChild = createUseStyles({
  root: {
    boxShadow: "unset !important",
    overflow: "hidden",
    color: "#fff",
    "& .MuiPaper-root": {
      borderBottom: "1px solid #F4F4F4",
      boxShadow: "unset !important",
      marginBottom: "0 !important",
    },
    "& .MuiPaper-elevation": {
      position: "relative",
    },
    "& .MuiAccordionSummary-root": {
      background: "#fff",
      color: "#444",
      fontWeight: "300",
      fontSize: "18px",
      padding: "0 32px",
      justifyContent: "flex-start",
      position: "relative",

      "& .MuiAccordionSummary-expandIconWrapper": {
        marginLeft: "18px",
        height: "6px",
      },
    },
    "& .MuiAccordionSummary-content": {
      flexGrow: "unset",
    },
    "& .MuiAccordion-root": {
      boxShadow: 0,
    },
  },
});

export const useStyles = createUseStyles(() => ({
  arrow: {
    "&:before": {
      border: "1px solid #FFF !important",
      backgroundColor: "#fff !important",
    },
    color: "#fff",
  },
  tooltip: {
    display: "block",
    backgroundColor: "#fff !important",
    color: "#444444 !important",
    fontWeight: "400 !important",
    fontSize: "18px !important",
    padding: "16px !important",
    boxShadow: "0px 4px 20px rgba(95, 95, 95, 0.15)",
    borderRadius: "8px",
    transition: "none",
    lineHeight: "27px !important",
    marginRight: "0 !important",
  },
}));
